import { WIZ_COMMAND_STATE, WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizCommand } from './wiz-command';

// une pile de commandes
export class WizGroupCommand {

  // UUID generated by constructor
  public uuid: string;

  // Command state
  public state: string;

  // Result callback
  public callback: Function;

  // Asynchronous mode
  // default : true. tout en même temps
  public asynchrone: boolean = true;

  // Service return on success
  public result: unknown;

  // Command pile
  public commandPile: WizCommand<any>[];
  private commandPopPile: WizCommand<any>[]; // Reverse command pile used for synchronous pop

  // Call pile
  // each call wil be stored (source observable to fill)
  // key = command uuid , value = the command
  private commandPileControl: Map<string, WizCommand<any>> = new Map();

  // Child callback method (asynchronous mode)
  public childAsyncCallbackBind: Function;

  /**
   * Additional listeners that want to know the end result of this method
   */
  private _attachedListeners: Function[];

  public carrier: any; // objet pour traitement éventuel sur retour

  constructor() {
    this.uuid = WizMathUtils.createUUID();
  }


  // Configuration method
  // @param pCommands : Command array
  // @param pCallBack : Callback function for result transmission
  // @param pAsync : Asynchronous mode
  // @return this
  public configure(pCommands: WizCommand<any>[],
                    pCallback: Function = null,
                    pAsync: boolean = true): WizGroupCommand {

    // Bind sur callback de retour des WizCommands (Async)
    this.childAsyncCallbackBind =  (obj: WizCommand<any>) => this.childAsyncCallback(obj);
    this.childAsyncCallbackBind = this.childAsyncCallback.bind(this);

    this.commandPile = pCommands; // ajout à la pile, ordonnée
    this.commandPopPile = [];
    this.commandPopPile = this.commandPopPile.concat(pCommands.reverse());

    // ajout au dico Cmd.UUID = > Cmd pour suivi du résultat
    this.commandPileControl = new Map();
    for (const wizCo of pCommands) {
      this.commandPileControl.set(wizCo.uuid, wizCo);
    }

    this.asynchrone = pAsync;
    this.callback = pCallback;
    return this;
  }

  /**
   * Let's you attach an additional listener to the group command.
   *
   * Once the command ends, every attachedListeners will be called.
   *
   * @param pListener The method / function to call once the GroupCommand ends. The state will be provided
   */
  public attach(pListener: (pState: string) => void): void {
    if (!this._attachedListeners) {
      this._attachedListeners = [];
    }

    this._attachedListeners.push(pListener);
  }

  /**
   * Call the attached listeners to let them know that every thing is done
   */
  protected callListeners(): void {
    if (this._attachedListeners && this._attachedListeners.length) {
      this._attachedListeners.forEach(listener => listener(this.state));
    }
  }

  // Return on call success
  public wizResult()  {
  }

  // Return on call failure
  public wizFault()  {
  }

  // Service call execution
  public async execute() {

    let wizCo: WizCommand<any>;
    if ( this.asynchrone) { // Asynchronous call, launch everything
      for (wizCo of this.commandPile) {

        wizCo.callback = this.childAsyncCallbackBind; // Single command callback overwrite
        wizCo.execute();
      }
    } else { // Synchronous mode, launching first command
      while (this.commandPopPile.length > 0) {
        wizCo = this.commandPopPile.pop();
        await wizCo.execute();
        if (!this.childSyncCallback(wizCo))
        {
          return Promise.resolve();
        }
      }
    }
    return Promise.resolve();
  }

  // Children process interception on asynchronous mode
  // @param result : WizCommand
  public childAsyncCallback( result: unknown ) {

    const wizDone: WizCommand<any> = result as WizCommand<any>;
    // Command map update
    this.commandPileControl.set(wizDone.uuid, wizDone);

    let allOk: boolean = true;
    let allDone: boolean = true;

    for ( let wizCo of this.commandPile) {
      wizCo = this.commandPileControl.get(wizCo.uuid);
      if (wizCo.state !== WIZ_COMMAND_STATE.SUCCESS) {
        allOk = false;
      }
      if (wizCo.state !== WIZ_COMMAND_STATE.SUCCESS && wizCo.state !== WIZ_COMMAND_STATE.FAULT) {
        allDone = false;
      }
    }

    if (allDone) { // All is done
      if ( allOk ) { // all is successfull
        this.state = WIZ_COMMAND_STATE.SUCCESS;
        this.wizResult();
      } else { // not successfull
        this.state = WIZ_COMMAND_STATE.FAULT;
        this.wizFault();
      }

      if ( this.callback ) {
        this.callback (this);
      }

      this.callListeners();
    }
  }

  // Children process interception on synchronous mode
  // @param result : WizCommand
  // @return false if the group command must stop (if command on error)
  public childSyncCallback( result: unknown ): boolean {
    let validGroupCall: boolean = true;
    const incomingCmd: WizCommand<any> = result as WizCommand<any>;
    this.commandPileControl.set(incomingCmd.uuid, incomingCmd);
    // command return managing
    // if error, end
    if ( incomingCmd.state === WIZ_COMMAND_STATE.FAULT) {
      validGroupCall = false;
      this.state = WIZ_COMMAND_STATE.FAULT;
      this.wizFault();

      if ( this.callback ) {
        this.callback (this);
      }

      this.callListeners();
    } else if ( this.commandPopPile.length === 0 ) { // end, all OK
        this.state = WIZ_COMMAND_STATE.SUCCESS;
        this.wizResult();

        if ( this.callback ) {
          this.callback (this);
        }

        this.callListeners();
    }
    return validGroupCall;
  }
}
